import { useEffect } from 'react';

import axios from 'axios';

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';

// Shown whenever any API request is rejected with 429 so users can report
// throttling instead of each caller handling it on its own.
const ThrottledRequestModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 429) {
          onOpen();
        }
        return Promise.reject(error);
      },
    );

    return () => axios.interceptors.response.eject(interceptor);
  }, [onOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Too many requests</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={3}>
            The system received too many requests in a short time, so your last
            action may not have completed. Please wait a moment and try again.
          </Text>
          <Text>
            If you see this message often, please let the support team know.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="brand" onClick={onClose}>
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ThrottledRequestModal;
